
import { mapGetters } from 'vuex'
import SearchCard from '../Search/SearchCard.vue'
import EralpPagination from 'gurhan/vue/BootstrapPagination.vue'
import NoFound from '../Shared/NoFound/index.vue'
import Payment from './Payment'
import ProductAlert from './ProductAlert.vue'
import Upload from '../Shared/Upload/index.vue'
import Accordion from '../Shared/Accordion/index.vue'
import { convertM2H } from '~/plugins/date'
import GetOffer from './GetOffer.vue'
import AnswerToOffer from './AnswerToOffer.vue'
import Purchase from '@/components/Contents/PurchaseAction/Purchase.vue'

export default {
  components: {
    SearchCard,
    NoFound,
    EralpPagination,
    ProductAlert,
    GetOffer,
    AnswerToOffer,
    Upload,
    Purchase,
    Accordion,
  },
  mixins: [Payment],
  data() {
    return {
      page: 1,
      productKeys: 1,
      showPayments: false,
      product: {}

    }
  },
  computed: {
    ...mapGetters({
      getRedirectUrl: 'getRedirectUrl',
      getUserIP: 'user/getUserIP',
      getEvents: 'profile.events/getEvents',
      getCount: 'profile.events/getEventsCount',
      getEventsLoading: 'profile.events/getEventsLoading',
    }),
    pages() {
      return Math.ceil(this.getCount / 12)
    },
  },
  methods: {
    BUY_IT_OFFER(product) {
      this.product = product
      this.showPayments = true;
    },
    SET_TIME(item) {
      if (item.isPinned) return false
      const date = this.$date.getTimeWithoutOffset(item.date)
      const time = 30 * 60000
      const total = date - time
      const remain = (total - new Date().getTime()) / 60000
      return remain < 0
    },
    SET_TIME_EXPIRED_AT(item) {
      if (item.isPinned) return false
      const date = this.$date.getTimeWithoutOffset(item.date)
      const total = date
      const remain = (total - new Date().getTime()) / 60000
      return remain > 0
    },
    SET_DISABLED_EVENT(item) {
      if (item.isPinned) return false
      const date = this.$date.getTimeWithoutOffset(item.date)
      const time = 30 * 60000
      const duration = item.duration * 60000
      const total = date + time + duration
      const remain = (total - new Date().getTime()) / 60000
      return remain < 0
    },
    SET_ACTIVE_EVENT(item) {
      if (item.isPinned) return false
      const date = this.$date.getTimeWithoutOffset(item.date)
      const duratiion = item.duration * 60000 // 2 saat 15 dk
      const total = date + duratiion // 21:15
      const starttotal = date // 18:00
      const today = new Date().getTime() // 18:21
      const remain = starttotal < today && today < total
      return remain
    },
    async SET_PAGINATION(page) {
      this.page = page
      await this.$store.dispatch('profile.events/GET_EVENTS', {
        page: this.page,
        currency: this.getUserIP.currency,
      })
      this.productKeys += 1
      window.scrollTo(0, 300)
    },
    SET_DATE(date, time) {
      return this.$date.format(date)
    },
    convertM2H(time, offset = true, gmt = false) {
      return convertM2H(time, this.getUserIP.offset, offset, gmt)
    },
  },
  async mounted() {
    await this.$store.dispatch('profile.events/GET_EVENTS', {
      page: 1,
      currency: this.getUserIP.currency,
    })
  },
}
